"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _WorkOrderEntity = _interopRequireDefault(require("@services/WorkOrderEntity"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      innerVisible: false,
      form: {},
      closeTitle: this.$t('close'),
      wid: '',
      closeNum: 0
    };
  },
  methods: {
    open: function open(obj, num) {
      this.closeNum = num;
      if (num) {
        this.closeTitle = this.$t('confirmClose');
      } else {
        this.closeTitle = this.$t('close');
      }
      this.innerVisible = true;
      this.form = _objectSpread({}, obj);
    },
    innerCancel: function innerCancel() {
      this.innerVisible = false;
      this.form = {};
      this.$refs['form'].resetFields();
    },
    innerConfirm: function innerConfirm() {
      this.submit();
    },
    submit: function submit() {
      var _this = this;
      if (this.closeNum) {
        return this.handleDispose();
      }
      _WorkOrderEntity.default.updateOrderStatus(_objectSpread(_objectSpread({}, this.form), {}, {
        optid: localStorage.name
      })).then(function (res) {
        var code = res.code,
          msg = res.msg;
        if (code === 200) {
          _this.innerCancel();
          _this.$message.success(_this.$t('closedSuccess'));
          _this.$parent.freshList();
        } else {
          _this.$message.error(msg);
        }
      }).catch();
    },
    handleDispose: function () {
      var _handleDispose = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$EntityService$, msg, code;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _WorkOrderEntity.default.updateOrderStatus(_objectSpread(_objectSpread({}, this.form), {}, {
                optid: localStorage.name
              }));
            case 2:
              _yield$EntityService$ = _context.sent;
              msg = _yield$EntityService$.msg;
              code = _yield$EntityService$.code;
              if (code === 200) {
                this.$message.success(this.$t('closedSuccess'));
                this.$parent.freshList();
                this.innerCancel();
                // this.$store.dispatch('getNumber')
              } else {
                this.$message.error(msg);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleDispose() {
        return _handleDispose.apply(this, arguments);
      }
      return handleDispose;
    }()
  }
};